// extracted by mini-css-extract-plugin
export default {"card":"ShowFriends_card__WmuFg"};